<div class="content">
    <div class="left">
        @if (dataLoaded) {
        <app-calendar [events]="eventDays" [blocked]="blockedDays"
            (monthChanged)="onMonthChanged($event)"></app-calendar>
        } @else {
        <div class="loading-calendar">
            <p>Cargando calendario...</p>
        </div>
        }
        <mat-divider></mat-divider>
        <div class="days-blocked">
            <h3>DÍAS BLOQUEADOS</h3>
            <div class="days">
                <div class="day">
                    @if (thisMonthBlockedDays.length === 0) {
                    <p>No hay días bloqueados este mes</p>
                    } @else {
                    @for (blockedDay of thisMonthBlockedDays; track blockedDay.id) {
                    <p>{{ formatDate(blockedDay.date) }}</p>
                    }
                    }
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>

        @if (thisMonthEventDays.length > 0) {
        @for (eventDay of thisMonthEventDays; track eventDay.id; let last = $last) {
        <div class="corporative">
            <h3>EVENTO CORPORATIVO ({{ formatDate(eventDay.date) }})</h3>
            <mat-form-field appearance="outline">
                <mat-label>Nombre del evento</mat-label>
                <input matInput [value]="eventDay.reason" readonly>
            </mat-form-field>
        </div>
        @if (!last) {
        <mat-divider></mat-divider>
        }
        }
        } @else {
        <div class="corporative">
            <h3>No hay eventos corporativos este mes</h3>
        </div>
        }
    </div>

    <div class="right">
        <h4>Información</h4>
        <p>Tiempo máximo para hacer su reserva: hasta el día anterior a las 15h laborable (no en domingo o festivo).</p>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="available"></div>
            <p>Días disponibles para reservar.</p>
        </div>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="selected"></div>
            <p>Día seleccionado.</p>
        </div>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="event"></div>
            <p>Evento corporativo: Serveto invita a todos los trabajadores al comedor de manera gratuita.</p>
        </div>
        <mat-divider></mat-divider>
        <div class="line">
            <div class="blocked"></div>
            <p>Día bloqueado, no puede hacer reservas.</p>
        </div>
        <mat-divider></mat-divider>
        <p class="cancel">Anular reserva</p>
        <p>Tiempo máximo para anular su reserva: hasta el día anterior a las 15h laborable (no en domingo o festivo).
        </p>
    </div>

</div>